import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators'
import store from '@/store'
import { IVendorCoverage, IVendorCoverageSet } from '@/api/types-vendor'

export const defaultItem: IVendorCoverageSet = {
  vendorCoverageSetId: 0,
  vendorId: 0,
  name: '',
  description: '',
  vendorCoverages: [],
  vendorProducts: []
}

export const defaultCoverage: IVendorCoverage = {
  vendorCoverageId: 0,
  vendorCoverageSetId: 0,
  allCounty: false,
  stateFips: '',
  state: '',
  countyFips: '',
  county: '',
  city: '',
  postalCode: '',
  lenderRestriction: '',
  inspType1: true,
  inspType2: true,
  inspType3: true,
  inspType4: true,
  inspType5: true,
  distance: 0,
  zipList: []
}

export interface IVendorCoverageSetsState {
  VendorCoverageSetList: IVendorCoverageSet[]
  VendorCoverageSetSelected: (IVendorCoverageSet | null)
}

@Module({ dynamic: true, store, name: 'VendorCoverageSets' })
class VendorCoverageSets extends VuexModule implements IVendorCoverageSetsState {
  public VendorCoverageSetList: IVendorCoverageSet[] = []
  public VendorCoverageSetSelected: IVendorCoverageSet | null = null
  public VendorCoverageSetVendorId = 0

  @Mutation
  private DEL_ALL_LIST() {
    this.VendorCoverageSetList = []
  }

  @Mutation
  private LOAD_LIST(list: IVendorCoverageSet[]) {
    this.VendorCoverageSetList = list
  }

  @Mutation
  private SET_VENDORID(vendorId: number | 0) {
    this.VendorCoverageSetVendorId = vendorId || 0
  }

  @Mutation
  private SET_SELECTED(item: IVendorCoverageSet | null) {
    this.VendorCoverageSetSelected = item
    this.VendorCoverageSetVendorId = item?.vendorId || 0
  }

  @Mutation
  private UPDATE_ITEM(item: IVendorCoverageSet) {
    for (let v of this.VendorCoverageSetList) {
      if (v.vendorCoverageSetId === item.vendorCoverageSetId) {
        v = Object.assign(v, item)
        break
      }
    }
  }

  @Action
  public createNewItem(vendorId: number): IVendorCoverageSet {
    const result = defaultItem
    result.vendorId = vendorId
    this.SET_VENDORID(vendorId)
    return result
  }

  @Action
  public loadList(vendorId: number, list: IVendorCoverageSet[]) {
    this.DEL_ALL_LIST()
    this.LOAD_LIST(list)
    this.SET_VENDORID(vendorId)
  }

  @Action
  public clearList(vendorId: number) {
    this.DEL_ALL_LIST()
    this.SET_VENDORID(vendorId)
  }

  @Action
  public setSelectedItem(item: IVendorCoverageSet) {
    this.SET_SELECTED(item)
  }

  @Action
  public updateItem(item: IVendorCoverageSet) {
    if (this.VendorCoverageSetSelected == null) return
    if (this.VendorCoverageSetSelected.vendorCoverageSetId !== item.vendorCoverageSetId) return
    this.SET_SELECTED(item)
    this.UPDATE_ITEM(item)
  }
}

export const VendorCoverageSetsModule = getModule(VendorCoverageSets)
